<ng-container *ngIf="!isActive">
    <p class="mb-0">Cette annonce n'est plus publiée.</p>
</ng-container>
<ng-container *ngIf="isActive && isOwner">
    <p>
        Vous avez publié cette annonce<ng-container *ngIf="publisher.publisher_company"> pour {{ publisher.publisher_company }}</ng-container>.
        Mode de mise en relation : <b>{{ isDirect ? 'Direct' : 'Rappel' }}</b>.
    </p>
    <ng-container *ngIf="isDirect">
        <p>Les personnes intéressées voient ces coordonnées :</p>
        <div class="row">
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_name">
                <label>Société</label>
                <b>{{ favorite.ad.owner_name }}</b>
            </div>
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_contact">
                <label>Contact</label>
                <b>{{ favorite.ad.owner_contact }}</b>
            </div>
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_phone">
                <label>Téléphone</label>
                <b>{{ favorite.ad.owner_phone }}</b>
            </div>
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_email">
                <label>Email</label>
                <b>{{ favorite.ad.owner_email }}</b>
            </div>
        </div>
        <p class="text-grey fs-small">Pour les modifier, mettez à jour votre nom, votre email et votre mobile dans <a routerLink="/app/user/account">Mon compte</a>.</p>
    </ng-container>
    <ng-container *ngIf="!isDirect">
        <p>Les personnes intéressées ne voient pas vos coordonnées : c'est à vous de les recontacter.</p>
    </ng-container>
    <p class="mb-0">
        Retrouvez tous les leads reçus dans l'onglet <a [routerLink]="leadsTabLink">Leads</a> de cette annonce
        et, toutes annonces confondues, sur la page <a routerLink="/app/favorites/leads">Mes leads</a>.
    </p>
</ng-container>
<ng-container *ngIf="isActive && !isOwner && !interested">
    <p>Ce bien est proposé par un professionnel partenaire de LyBox<ng-container *ngIf="publisher?.publisher_company"> ({{ publisher.publisher_company }})</ng-container>.</p>
    <button class="btn btn-primary" (click)="interest()" [disabled]="loading">
        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">
            <i class="fa fa-handshake-o"></i> Je suis intéressé par le projet
        </ng-container>
    </button>
</ng-container>
<ng-container *ngIf="isActive && !isOwner && interested">
    <ng-container *ngIf="isDirect; else rappel">
        <p>Contactez directement le professionnel qui propose ce bien :</p>
        <div class="row">
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_name">
                <label>Société</label>
                <b>{{ favorite.ad.owner_name }}</b>
            </div>
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_contact">
                <label>Contact</label>
                <b>{{ favorite.ad.owner_contact }}</b>
            </div>
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_phone">
                <label>Téléphone</label>
                <b><a href="tel:{{ favorite.ad.owner_phone }}">{{ favorite.ad.owner_phone }}</a></b>
            </div>
            <div class="col-md-6 indicateur" *ngIf="favorite.ad.owner_email">
                <label>Email</label>
                <b><a href="mailto:{{ favorite.ad.owner_email }}">{{ favorite.ad.owner_email }}</a></b>
            </div>
            <div class="col-12 mt-2" *ngIf="adUrl">
                <a class="btn btn-sm btn-outline" href="{{ adUrl }}" target="_blank" rel="noopener">
                    <i class="fa fa-external-link"></i> Voir l'annonce
                </a>
            </div>
        </div>
    </ng-container>
    <ng-template #rappel>
        <p class="text-success mb-0"><i class="fa fa-check me-2"></i>Merci, vous serez recontacté prochainement par le professionnel qui propose ce bien.</p>
    </ng-template>
</ng-container>
